import { API_PREFIX, API_TIMEOUT, BASE_URL, NODE_ENV, SECRET_KEY } from '@configs/api.config'
import logger from '@libs/logger'
import axios, { AxiosRequestConfig } from 'axios'
import { LANGUAGE_CODE, LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { ELanguage } from '@src/configs/interface.config'
import { checkAuth, getLocalStored } from '@libs/localStorage'
import { enc, HmacSHA256 } from 'crypto-js'

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

const client = axios.create({
  baseURL: BASE_URL + API_PREFIX,
  timeout: API_TIMEOUT,
  timeoutErrorMessage: '🚧🚧🚧 Server connection time out !',
})

export const request = async (
  options: AxiosRequestConfig,
  additional?: { lang?: ELanguage | string; token?: string },
) => {
  logger.debug('🚧🚧🚧 ~ Axios Options:', options)

  // Init default headers request
  client.defaults.headers.Accept = 'application/json'
  client.defaults.headers.xsrfCookieName = 'XSRF-TOKEN'
  client.defaults.headers.xsrfHeaderName = 'X-XSRF-TOKEN'
  client.defaults.headers.responseEncoding = 'utf8'
  client.defaults.responseType = 'json'
  client.defaults.headers['Content-Type'] = 'application/json'
  client.defaults.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate'
  client.defaults.headers['Access-Control-Allow-Origin'] = '*'
  client.defaults.headers['X-Application'] = 'web app'
  client.defaults.headers['X-Version'] = '0.1.0'

  client.defaults.headers.timezone = timezone

  // if (NODE_ENV === 'production') {
  const data = `${options?.method || 'GET'}:${API_PREFIX}/${options.url}`
  client.defaults.headers.common['x-csrf-token'] = HmacSHA256(data, SECRET_KEY).toString(enc.Hex)
  // }

  client.defaults.headers.common.Authorization = `Bearer ${additional?.token || checkAuth() || undefined}`

  client.defaults.headers.common.lang = getLocalStored('lang')
    ? LANGUAGE_CODE.includes(getLocalStored('lang'))
      ? getLocalStored('lang')
      : LANGUAGE_DEFAULT
    : LANGUAGE_DEFAULT

  const onSuccess = (response: any) => {
    logger.debug('🚀🚀🚀 ~ Response API:', response?.data)
    return response?.data
  }
  const onError = async (error: any) => {
    logger.error('🚨🚨🚨 ~ Axios onError:', onError)
    await Promise.reject({
      statusCode: error?.response?.data?.statusCode,
      message: error?.response?.data?.message,
      statusText: error?.response?.statusText,
      status: error?.response?.status,
      data: error?.response?.data?.data || null,
    })
  }
  return client(options).then(onSuccess).catch(onError)
}
